import { render, staticRenderFns } from "./opc.vue?vue&type=template&id=0d2f45ab&"
import script from "./opc.vue?vue&type=script&lang=js&"
export * from "./opc.vue?vue&type=script&lang=js&"
import style0 from "./opc.vue?vue&type=style&index=0&id=0d2f45ab&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports